import { useDispatch } from "react-redux";
import { useCreateLocationMutation } from "../../../Store/Builder/techsbook.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";

const useCreateLocationApi = () => {
  const dispatch = useDispatch();
  const [create] = useCreateLocationMutation();

  const send = (body, setModal) => {
    dispatch(setLoader(true));
    create(body)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        showToast(res?.message ?? "Success", "success");
        setModal();
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    send,
  };
};

export default useCreateLocationApi;
